export default __webpack_public_path__ + "static/media/bb.12664230.png";